import { useState as f, useRef as l, useCallback as t, useMemo as m } from "react";
import { v4 as p } from "uuid";
function h() {
  const [c, u] = f({}), n = l(c);
  n.current = c;
  const b = t(
    (s) => {
      const r = p();
      return u((e) => ({ ...e, [r]: s })), r;
    },
    []
  ), o = t(
    (s) => u((r) => {
      const e = { ...r };
      return delete e[s], e;
    }),
    []
  ), i = t(
    (s, r) => Object.values(n.current).forEach((e) => {
      var a;
      return (a = e[s]) == null ? void 0 : a.call(e, r);
    }),
    []
  );
  return m(
    () => ({ subscribe: b, unsubscribe: o, dispatch: i }),
    [i, b, o]
  );
}
export {
  h as u
};
//# sourceMappingURL=useSubscriptionHandler-D4p0pO3P.js.map
